import { Skeleton } from "./ui/skeleton";

/**
 * What a page looks like for the moment its chunk is still downloading.
 *
 * Every route is `React.lazy`, so the first visit to a screen suspends while
 * its JavaScript arrives. Deliberately the same two-bar skeleton the gate shows
 * on first load: an operator clicking through the sidebar should see one
 * loading shape, not a spinner here and a skeleton there.
 */
export function RouteFallback() {
  return (
    <div className="flex flex-col gap-4 p-6">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
